module.exports = "/_next/static/images/arrow-down-3ec57623c6fa9694b9be93c6dda145ec.png";